const getCompanyId = (company) => company?._id || company;

export const filterProdluctIdsByCompanyId = (
	products = [],
	productIds = [],
	companyId,
) =>
	productIds.filter((productId) =>
		products.find(
			(product) =>
				product._id === productId && getCompanyId(product.company) === companyId,
		),
	);
